export const loginWithK12ScreenStyles = `
  .raj-root {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: var(--space-4);
  }
`;
